<template>
   <div
      class="flightcard-inner-wrapper"
      :class="[
         flight.familyPrice != null ? 'has-family-price' : '',
         flight.familyPrice == 0 ? 'not-has-family-price' : '',
         flight.isSelected ? 'is-selected' : '',
         flight.isSelected && !isOneWay && flight.familyPrice != null && FamilyPriceView.basketCreated && !FamilyPriceView.checkoutEnabled ? 'de-emphasize' : '',
         isPackagePrice() ? 'is-package' : '',
         familyPricesToggle && flight.cheapestFamilyPrice?.price && !isCheckOutEnabled && !flight.isSelected ? getClassForFamilyPriceView(flight.cheapestFamilyPrice?.price) : '',
         flight.isHiddenFromUI ? 'flightcard-collapsed' : '',
      ]"
      :data-identifier="flight.identifier"
      :data-price="flight.price"
      v-if="FilterBy"
      :data-leg="flight.legIndex">
      <ul v-if="false" @click="handlerSelectFlight">
         <li>
            <span>isSelected:</span>
            <span>{{ flight.isSelected }}</span>
         </li>
         <li>
            <span>priceViewMode:</span>
            <span>{{ priceViewMode }}</span>
         </li>
         <li>
            <span>familiesPackagePrices:</span>
            <span>{{ flight.familiesPackagePrices }}</span>
         </li>
         <li>
            <span>family Price:</span>
            <span>{{ flight.familyPrice }}</span>
         </li>
         <li>
            <span>cheapestFamilyPrice:</span>
            <span>{{ flight.cheapestFamilyPrice?.price }}</span>
         </li>
         <li>
            <span>Price:</span>
            <span>{{ flight.price }}</span>
         </li>
         <li>
            <span>isCheckOutEnabled:</span>
            <span>{{ isCheckOutEnabled }}</span>
         </li>
      </ul>
      <template v-else>
         <div class="flightcard-header d-lg-none">
            <div class="flightcard-header-left">
               <img class="airline-logo" :src="handlerAirlineImg(flight.marketingAirlineCode)" alt="" @error="handlerUnknownImg($event)" />
               <div class="airline-informations">
                  <div class="marketing-airline">
                     <span class="airline">{{ flight.marketingAirline }}</span>
                  </div>
                  <div class="operating-airline">
                     <span class="operated-by"> {{ $t("flightCard_operatedBy") }} : </span>
                     <span class="airline">{{ flight.operatingAirline }}</span>
                  </div>
               </div>
            </div>

            <!-- Charter Badge Mobile -->
            <div class="flightcard-header-right">
               <span class="is-charter" v-if="flight.isCharter">charter</span>
               <div class="badge-wrapper">
                  <div class="badge-item is-ethnic" v-if="flight.paxSubType != 0">{{ $t("flightCard_paxSubType") }}</div>
               </div>
            </div>
         </div>

         <div :data-flightNumber="flight.flightNumber" class="flightcard-basics-wrapper" @click="handlerSelectFlight">
            <div class="badge-wrapper">
               <div class="badge-item is-charter d-none d-lg-block" v-if="flight.isCharter">charter</div>

               <div class="badge-item is-ethnic d-none d-lg-block" v-if="flight.paxSubType != 0">{{ $t("flightCard_paxSubType") }}</div>
               <div
                  class="badge-item is-family-offer d-none d-lg-block"
                  :class="getClassForFamilyPriceView(flight.cheapestFamilyPrice?.price)"
                  v-if="familyPricesToggle && flight.cheapestFamilyPrice?.price && !isCheckOutEnabled && !flight.isSelected">
                  {{ $t("flightCardComponent_lblPricePackage") }}: <strong>{{ flight.cheapestFamilyPrice?.price | price(currency) }}</strong>
               </div>
            </div>

            <template v-if="false">
               <div class="cheapest-family-offer" :class="getClassForFamilyPriceView(flight.cheapestFamilyPrice?.price)" v-if="flight.cheapestFamilyPrice?.price">
                  <i class="gts-icon icon-sm icon-package"></i>
                  <span> {{ $t("searchComponentFlight_cheapestPrice") }}</span>
                  <span>{{ flight.cheapestFamilyPrice?.price | price(currency) }}</span>
               </div>
            </template>

            <!-- SELECT BUTTON -->
            <div class="flightcard-selection-wrapper">
               <div class="flightcard-selection-checkmark"></div>
            </div>

            <!-- AIRLINE INFORMATION -->
            <div class="flightcard-airline-informations d-none d-lg-flex">
               <img class="airline-logo" :src="handlerAirlineImg(flight.marketingAirlineCode)" alt="" @error="handlerUnknownImg($event)" />
               <span class="marketing-airline-name">{{ flight.marketingAirline }}</span>
               <span class="flight-channel" v-if="isChannel">{{ flight.channel }}</span>
            </div>

            <!-- PRICE & CABINTYPE INFORMATIONS -->
            <div class="flightcard-main-informations-wrapper">
               <!-- Tekli Gösterim -->
               <template>
                  <div class="flightcard-main-informations" :class="[isPackagePrice() ? 'single-view' : '', flight.familyPrice == 0 && flight.price == 0 ? 'hide-from-ui' : '']">
                     <!-- Price Section -->
                     <div class="flightcard-price-wrapper">
                        <!-- Display if it is one way  -->

                        <template v-if="flight.price == 0 && flight.familyPrice == 0 && typeof flight.familiesPackagePrices == 'undefined'">
                           <span class="flightcard-price-oneway"> {{ $t(`flightCardComponent_lblPriceSingle`) }}</span>
                        </template>

                        <template v-else>
                           <!-- Display if discount -->
                           <template v-if="flight.familyPrice != 0 && flight.familyPrice != null && flight.price != flight.familyPrice">
                              <span class="flightcard-single-price"> {{ $t(`flightCardComponent_lblPriceSingle`) }}</span>
                              <span class="flightcard-discount" v-if="isPackagePrice()"> {{ flight.price | price(currency) }} </span>
                              <span class="flightcard-price cut-price family-price" v-if="isPackagePrice()"> {{ flight.familyPrice | price(currency) }}</span>
                              <span class="flightcard-price cut-price" v-else> {{ flight.price | price(currency) }}</span>
                           </template>

                           <template v-if="flight.familyPrice === 0 || flight.familyPrice == null || flight.price === flight.familyPrice">
                              <span class="flightcard-single-price" v-if="!isOneWay"> {{ $t(`flightCardComponent_lblPriceSingle`) }} </span>
                              <span class="flightcard-price"> {{ flight.price | price(currency) }}</span>
                           </template>
                        </template>
                     </div>

                     <template v-if="!isPackagePrice()">
                        <span class="flightcard-cabintype">{{ flight.cabinType | EFltCabinType }} </span>

                        <div class="flightcard-baggage-seat-informations">
                           <div class="baggage-wrapper">
                              <i class="gts-icon icon-xs icon-baggage"></i>
                              <span class="baggage-information" v-if="flight.baggage.status">{{ flight.baggage.info }}</span>
                              <span class="baggage-information" v-else>{{ flight.baggage.info }}</span>
                           </div>
                           <div class="seat-wrapper">
                              <i class="gts-icon icon-xs icon-seat"></i>
                              <span class="seat-information">{{ flight.leftSeat }}</span>
                           </div>
                        </div>
                     </template>
                  </div>
               </template>

               <!-- Package  Gösterim -->
               <template>
                  <div class="flightcard-main-informations package-price" v-if="isPackagePrice()">
                     <!-- Price Section -->
                     <div class="flightcard-price-wrapper">
                        <template>
                           <!-- Display if discount -->
                           <template>
                              <span class="flightcard-single-price"> {{ $t(`flightCardComponent_lblPricePackageShorter`) }}</span>
                              <span class="flightcard-price cut-price"> {{ flight.familiesPackagePrices | price(currency) }}</span>
                           </template>
                        </template>
                     </div>

                     <template>
                        <span class="flightcard-cabintype">{{ flight.cabinType | EFltCabinType }} </span>

                        <div class="flightcard-baggage-seat-informations">
                           <div class="baggage-wrapper">
                              <i class="gts-icon icon-xs icon-baggage"></i>
                              <span class="baggage-information" v-if="flight.baggage.status">{{ flight.baggage.info }}</span>
                              <span class="baggage-information" v-else>{{ flight.baggage.info }}</span>
                           </div>
                           <div class="seat-wrapper">
                              <i class="gts-icon icon-xs icon-seat"></i>
                              <span class="seat-information">{{ flight.leftSeat }}</span>
                           </div>
                        </div>
                     </template>
                  </div>
               </template>
            </div>

            <FlightCardInfoGraphic :segments="flight.segments" :transfer-time="flight.transferTime" :connection="flight.connection" />

            <!-- SHOW/HIDE DETAILS  -->
            <div class="flightcard-details-toggle d-none d-xxl-inline-flex" :class="showDetails ? 'hide-details' : ''" data-toggle>
               <i class="gts-icon icon-arrow-down icon-sm"></i>
            </div>
         </div>

         <FlightCardDebugger :infos="Debugger" v-if="isDebugger" />

         <FlightCardDetails v-if="showDetails" :details="flight.details" />

         <!-- FlightCard Footer -->
         <div class="flightcard-footer-wrapper">
            <!-- Last Seat Attention -->
            <span class="last-seat-attention" :class="flight.leftSeat <= 9 ? 'seat-visible' : ''">
               <i class="gts-icon icon-flame icon-xs"></i>
               {{ $t("searchComponentFlight_lastSeat") }} {{ flight.leftSeat }}
            </span>

            <!-- Operating Airlines -->
            <span class="operating-airline-name d-none d-xl-block" v-if="flight.operatingAirlineCode != flight.marketingAirlineCode"
               >{{ $t("flightcardcomponent_operatedBy") }}: {{ $t(`airlineEnum_${flight.operatingAirlineCode}`) }}
            </span>

            <!--  Show Details Mobile -->
            <div class="flightcard-details-toggle d-xxl-none" :class="showDetails ? 'hide-details' : ''" data-toggle @click="showDetails = !showDetails">
               <i class="gts-icon icon-eye-closed" v-if="showDetails"></i>
               <i class="gts-icon icon-eye" v-else></i>
               <span class="toggle-detail-txt">{{ $t("flightCard_showDetails") }}</span>
            </div>

            <!-- Connections -->
            <span class="connections d-none d-xxl-block">
               {{ flight.stopCount }}
            </span>
         </div>
      </template>
   </div>
</template>

<script>
import { format24hours, convertToHour } from "@/helper/flight.js";
import FlightCardInfoGraphic from "@/components/structural/flight/search/search-results/flight-card/FlightCardInfoGraphic.vue";
import FlightCardDebugger from "@/components/structural/flight/search/search-results/flight-card/FlightCardDebugger.vue";
import FlightCardDetails from "@/components/structural/flight/search/search-results/flight-card/FlightCardDetails.vue";

export default {
   name: "FlightCard",
   props: {
      flight: {
         type: Object,
         required: true,
      },
      flightIndex: Number,
      legIndex: Number,
      currency: String,
      cheapest: Object,
      familyPricesToggle: Boolean,
      paxsubtype: Number,
      isCheckOutEnabled: Boolean,
      priceViewMode: Number,
      isOneWay: Boolean,
      isDebugger: Boolean,
      isChannel: Boolean,
   },
   components: {
      FlightCardInfoGraphic,
      FlightCardDebugger,
      FlightCardDetails,
   },
   data() {
      return {
         showDetails: false,
      };
   },
   mounted() {
      // document.body.addEventListener("keydown", (event) => {
      //    let held = false;
      //    if (event.ctrlKey && event.altKey) {
      //       held = true;
      //    }
      //    if (held && event.keyCode == 73) {
      //       this.isDebugger = !this.isDebugger;
      //    }
      //    if (held && event.keyCode == 84) {
      //       this.isChannel = !this.isChannel;
      //    }
      // });
   },

   computed: {
      FlightCardPriceData() {
         return {
            familiesPackagePrices: this.flight.familiesPackagePrices,
            familyPrice: this.flight.familyPrice,
            cheapestFamilyPrice: this.flight.cheapestFamilyPrice,
            price: this.flight.price,
            currency: this.currency,
            cabinType: this.$options.filters.EFltCabinType(this.flight.cabinType),
            baggage: this.flight.baggage,
            leftSeat: this.flight.leftSeat,
            isSelected: this.flight.isSelected,
         };
      },
      FamilyPriceView() {
         return this.$parent.BasketCreatedAndHasSelection;
      },
      FilterBy() {
         const storeShortCut = this.$store.state.flight.filters[this.flight.legIndex].filters;

         //car filter options helper variables
         const departureTime = this.flight.segments[0].time;
         const arrivalTime = this.flight.segments[Object.keys(this.flight.segments).length - 1].time;
         const baggageAllowance = this.flight.baggage.status ? "withbaggage" : "nobaggage";

         //Card filter options
         const connection = storeShortCut.connections[this.flight.connection].checked;
         const cabintype = storeShortCut.cabintype[this.flight.cabinType].checked;
         const airlines = storeShortCut.airlines[this.flight.marketingAirlineCode].checked;
         const dpTakeOff = format24hours(storeShortCut.hours.departure[0]) <= departureTime;
         const dpLanding = format24hours(storeShortCut.hours.departure[1]) >= departureTime;
         const rtTakeoff = format24hours(storeShortCut.hours.arrival[0]) <= arrivalTime;
         const rtLanding = format24hours(storeShortCut.hours.arrival[1]) >= arrivalTime;
         const baggage = storeShortCut.baggage[baggageAllowance].checked;

         return connection && cabintype && airlines && dpTakeOff && dpLanding && rtTakeoff && rtLanding && baggage;
      },
      Debugger() {
         return {
            channel: this.flight.channel,
            identifier: this.flight.identifier,
            debugger: this.flight.debugger,
         };
      },
   },

   methods: {
      isPackagePrice() {
         if (this.isCheckOutEnabled) {
            // return this.flight.familiesPackagePrices != 0 && this.flight.familiesPackagePrices != undefined && this.priceViewMode == 1;
            return this.flight.familiesPackagePrices != 0 && this.flight.familiesPackagePrices != undefined && this.priceViewMode == 1;
         } else {
            return this.flight.familiesPackagePrices != 0 && this.flight.familiesPackagePrices != undefined;
         }
      },
      getClassForFamilyPriceView(cheapestFamilyPrice) {
         const { basketCreated, thisLegHasSelection, showKe, checkoutEnabled } = this.FamilyPriceView;

         // Check for the specific condition where all are false
         if (!basketCreated && !thisLegHasSelection && showKe.length === 0 && !checkoutEnabled) {
            return "green";
         }

         // Original conditions
         if (basketCreated && thisLegHasSelection && ((Array.isArray(showKe) && showKe.includes(cheapestFamilyPrice) && checkoutEnabled) || !checkoutEnabled)) {
            return "green";
         }

         return "gray";
      },
      handlerSelectFlight(ev) {
         const isNotSelection = ev.target.hasAttribute("data-toggle");
         if (isNotSelection) {
            this.showDetails = !this.showDetails;
         } else {
            this.$store.commit("flight/setLegSelection", { status: true, legIndex: this.legIndex, price: this.flight.price });
            this.$emit("selected-flight", { identifier: this.flight.identifier, index: this.flightIndex });
         }

         const sameDayFlight = this.$parent.$parent.$parent.$parent.$parent.sameDayFlight;
         if (sameDayFlight) {
            this.handlerSameDayControll();
         }
      },
      handlerSameDayControll() {
         const departureTime = convertToHour(this.flight.segments[0].time) - 2;
         const arrivalTime = convertToHour(this.flight.segments[Object.keys(this.flight.segments).length - 1].time) + 2;

         const otherFilter = this.legIndex == 1 ? 2 : 1;

         if (this.legIndex == 1) {
            const current = this.$store.state.flight.filters[otherFilter].filters.hours.departure[1];
            this.$store.state.flight.filters[otherFilter].filters.hours.departure = [arrivalTime, current];
         } else {
            const current = this.$store.state.flight.filters[otherFilter].filters.hours.arrival[0];
            this.$store.state.flight.filters[otherFilter].filters.hours.arrival = [current, departureTime];
         }
      },
      handlerAirlineImg(airlineLogo) {
         return `${this.$constants.cdn}/airline_34x34/${airlineLogo}.svg`;
      },
      handlerUnknownImg(ev) {
         ev.target.src = `${this.$constants.cdn}/airline_34x34/00.svg`;
      },
   },
};
</script>

<style lang="scss" scoped>
.green {
   .flightcard-basics-wrapper {
      padding: 1rem !important;
      padding-top: 2rem !important;
   }
}
$familyPriceColor: var(--green-300);
.single-view {
   padding: 0.25rem 0rem !important;
   padding-bottom: 0rem !important;

   .flightcard-single-price {
      font-size: 15px;
      top: -2rem;
   }

   &.hide-from-ui {
      display: none !important;
   }
}
.package-price {
   opacity: 1 !important;
   cursor: pointer !important;
   margin-top: 1.75rem;
   border: 3px solid $familyPriceColor !important;
   border: 3px solid var(--cyan-500) !important;

   background-color: var(--accent-primary-lighter);
   background-color: var(--teal-0) !important;
   border: 3px solid var(--accent-primary);
   /* box-shadow: 0px 0px 0px 4px var(--accent-primary-lighter); */
   box-shadow: var(--gts-box-shadow);
   /* -webkit-box-shadow: 0px 0px 0px 4px var(--accent-primary-lighter); */
   -webkit-box-shadow: var(--gts-box-shadow);
   /* -moz-box-shadow: 0px 0px 0px 4px var(--accent-primary-lighter); */
   -moz-box-shadow: var(--gts-box-shadow);
   transform: scale(1) !important;

   .cut-price {
      color: var(--cyan-600) !important;
      color: var(--primary) !important;
      color: var(--product-rentacar) !important;
      color: var(--cyan-600) !important;
      color: var(--cyan-700) !important;
      border-radius: 0.25rem;
   }
}

span.flightcard-cabintype {
   text-align: center;
   border-radius: 0.5rem;
   font-size: var(--small);
   font-weight: 500;
   color: var(--gray-800);
   width: fit-content;
}
.flightcard-baggage-seat-informations {
   display: flex;
   flex-direction: row;
   margin-top: 0.25rem;

   .baggage-wrapper,
   .seat-wrapper {
      display: flex;
      margin: 0 0.25rem;

      span {
         color: var(--orange-400);
         font-size: var(--small);
         font-weight: 500;
      }
   }
}
.flightcard-single-price {
   position: absolute;
   top: -2.125rem;
   font-size: 17px;

   padding: 0 0.5rem;
   border-radius: 0.5rem;

   color: var(--gray-900);
   font-weight: 600;
   white-space: nowrap;
}

.badge-wrapper {
   position: absolute;
   top: 0;
   right: 0;
   display: flex;
   gap: 0.25rem;

   .badge-item {
      border-radius: 5px !important;
      margin-right: 0.125rem;
      border-radius: 5px;
      padding: 0.15rem 0.5rem;
      font-size: var(--small);
      font-weight: 500;

      &:last-child {
         border-top-left-radius: 0;
         border-top-right-radius: 0.75rem !important;
         border-bottom-right-radius: 0;
         margin-right: 0 !important;
      }

      &.is-charter {
         background-color: var(--red-500);
         color: var(--gray-50) !important;
         outline: 1px solid var(--red-500);
      }
      &.is-ethnic {
         background-color: var(--purple-400);
         outline: 1px solid var(--purple-400);
         color: var(--gray-50) !important;
      }
      &.is-family-offer {
         font-weight: 400;

         strong {
            font-size: 1rem;
            font-weight: 600 !important;
         }
         &.gray {
            background-color: var(--gray-300);
            color: var(--gray-500);
            display: none !important;
         }
         &.green {
            border-top-left-radius: 0 !important;
            border-bottom-right-radius: 0 !important;
            background-color: $familyPriceColor;
            background-color: $familyPriceColor;
            outline: 1px solid $familyPriceColor;
            outline: 1px solid $familyPriceColor;
            border: none !important;
         }
      }
   }

   .is-charters {
      background-color: var(--red-500);

      font-size: var(--xsmall);
      //color: var(--gray-50);
      color: var(--gray-0);
      padding: 0.15rem 0.5rem;
      text-transform: uppercase;
      font-weight: 600;
   }
   .is-ethnics {
      background-color: var(--purple-400);
      border-radius: 5px;

      font-size: var(--xsmall);
      color: var(--gray-50) !important;
      padding: 0.15rem 0.5rem;
      text-transform: uppercase;
      font-weight: 600;
   }
   .is-family-offers {
      background-color: var(--green-400);
      border-radius: 5px;
      font-size: var(--xsmall);
      //color: var(--gray-50);
      color: var(--gray-0);
      padding: 0.15rem 0.5rem;
      text-transform: uppercase;
      font-weight: 400;
   }
}

.best-offer {
   background-color: var(--accent-primary);
   width: fit-content;
   padding: 0.25rem 1rem;
   border-radius: 1rem;
   border-top-right-radius: 0;
   border-bottom-left-radius: 0;
   //color: var(--gray-50);
   color: var(--gray-0);
   font-weight: 600;
   position: absolute;
   left: 0;
   top: 0;
}

.cheapest-family-price {
   position: relative;
   &::after {
      content: "*";
      position: absolute;
      top: 0;
      left: 0;
   }
}
.cheapest-family-offer {
   padding: 0.25rem 0.5rem;
   border-radius: 0.75rem;
   margin-top: 0.5rem;
   text-align: center;
   color: var(--gray-800);
   width: -moz-fit-content;
   width: fit-content;
   display: flex;
   flex-direction: column;
   align-items: center;

   &.gray {
      display: none;
      background-color: var(--gray-300);
      color: var(--gray-500);
   }
   &.green {
   }
   span {
      font-weight: 500;
      font-size: 1rem;
      &:first-child {
         line-height: 1rem;
         font-size: 0.85rem;
         font-weight: 400;
      }
   }
}
.flightcard-main-informations-wrapper {
   width: fit-content;
   align-items: center;
   display: flex;
   flex-direction: column;

   @media (min-width: 992px) {
      margin-left: 1rem;
   }
   @media (min-width: 1400px) {
      margin-left: 1.5rem;
      padding: 0.75rem 0.25rem;
   }
}
.flightcard-inner-wrapper {
   position: relative;

   //background-color: var(--gray-50);
   // background-color: var(--gray-0);
   // //background-color: var(--gray-50);
   // background-color: var(--gray-0);
   background-color: var(--container-bg);
   border: 1.5px solid var(--gray-300);
   margin-bottom: 1.125rem;
   border-radius: 1rem;

   cursor: pointer;
   outline: 3px solid transparent;
   transition-property: all;
   transition-timing-function: ease-in-out;

   .flightcard-header {
      background-color: var(--gray-200);
      padding: 0.25rem 0.5rem;
      border-radius: 1rem;
      border-bottom-right-radius: 0;
      border-bottom-left-radius: 0;
      height: 52px;
      display: flex;
      justify-content: space-between;

      .flightcard-header-left {
         display: flex;
         align-items: center;
         img {
            $size: 34px;
            width: $size;
            height: $size;
            margin-right: 0.75rem;
         }
         .airline-informations {
            .marketing-airline,
            .operating-airline {
               span {
                  font-size: var(--small);
               }
               span.airline,
               span.flight-number {
                  font-weight: 500;
               }
               span.flight-number {
                  margin-left: 0.5rem;
               }
            }
            .operating-airline {
               color: var(--gray-500);
               font-size: var(--xsmall) !important;
            }
         }
      }
      .flightcard-header-right {
         display: flex;
         align-items: center;
         .is-charter {
            margin-left: 0.5rem;
            //background-color: var(--gray-50);
            background-color: var(--gray-0);
            border: 2px solid var(--red-500);
            color: var(--red-500);
            border-radius: 0.5rem !important;
            font-size: var(--xsmall);
            padding: 0.15rem 0.5rem;
            text-transform: uppercase;
            font-weight: 600;
         }

         i {
            display: none;
         }
      }
   }

   &.de-emphasize {
      .flightcard-main-informations {
         opacity: 0.5 !important;
         transform: scale(0.9) !important;
      }
   }

   &.is-selected {
      .flightcard-basics-wrapper {
         .flightcard-main-informations {
            background-color: var(--accent-primary-lighter);
            border: 3px solid var(--accent-primary);
            // box-shadow: 0px 0px 0px 4px var(--accent-primary-lighter);
            // -webkit-box-shadow: 0px 0px 0px 4px var(--accent-primary-lighter);
            // -moz-box-shadow: 0px 0px 0px 4px var(--accent-primary-lighter);
         }
         .flightcard-selection-wrapper {
            border: 2px solid var(--accent-primary);
            .flightcard-selection-checkmark {
               display: block !important;
               $size: 20px;
               width: $size;
               height: $size;
               background: var(--accent-primary);
               border-radius: 50%;
               opacity: 1;
            }
         }
      }
   }
   &.is-package {
      .flightcard-basics-wrapper {
         .flightcard-main-informations {
            opacity: 0.4;
            cursor: not-allowed;
            transform: scale(0.85);

            .flightcard-price {
            }
         }
      }
   }

   &:hover {
      background-color: var(--gray-100);

      .flightcard-details-toggle {
         background-color: var(--gray-50) !important;
         border: 2px solid var(--gray-300);
      }
      .flightcard-selection-wrapper {
         transform: scale(1.05);
      }

      ::v-deep .flight-icon-container {
         background-color: var(--gray-100) !important;
         transform: scale(1.15);
      }
   }
   &.has-family-price {
      outline: 3px solid var(--teal-300);
      outline: 4px solid $familyPriceColor;
      border: 1px solid transparent;
      .is-charter {
      }

      &.not-has-family-pricek {
         outline: none !important;
      }
   }
   &.flightcard-collapsed,
   &.lazy-loaded-collapsed-leg {
      display: none;
   }
   &.details-active {
      background: var(--gray-50);
   }
}
.flightcard-inner-wrapper {
   .flightcard-basics-wrapper {
      display: flex;
      align-items: center;
      padding: 1rem;
      padding-bottom: 1rem;
      padding-top: 1.5rem;
      width: 100%;
      justify-content: space-between;
      flex-direction: row-reverse;
      @media (min-width: 992px) {
         flex-direction: row;
      }

      .flightcard-selection-wrapper {
         $size: 28px;
         width: $size;
         height: $size;
         display: inline-flex;
         flex-shrink: 0;
         border: 3px solid var(--gray-400);
         border-radius: 50%;
         align-items: center;
         justify-content: center;
         //background-color: var(--gray-50);
         background-color: var(--gray-0);
         transition-property: transform;

         transition-timing-function: ease-in-out;
         margin-right: 1rem;
         @media (max-width: 1800px) {
            display: none;
         }

         .flightcard-selection-checkmark {
            opacity: 0;
            transition-property: opacity;
            transition-timing-function: ease-in-out;
         }

         &.is-selected {
            border: 2px solid var(--accent-primary);
            .flightcard-selection-checkmark {
               display: block !important;
               $size: 20px;
               width: $size;
               height: $size;
               background: var(--accent-primary);
               border-radius: 50%;
               opacity: 1;
            }
         }
      }
      .flightcard-details-toggle {
         display: inline-flex;
         flex-shrink: 0;
         align-items: center;
         justify-content: center;
         $size: 42px;
         width: 36px;
         height: $size;

         border-radius: 0.5rem;
         background-color: var(--gray-200);

         i {
            margin-top: 3px;
            pointer-events: none;
            transform: rotate(0deg);
            transition-property: transform;
            transition-timing-function: ease-out;
         }

         &.hide-details {
            i {
               transform: rotate(180deg);
            }
         }
      }
      .flightcard-airline-informations {
         display: flex;
         flex-direction: column;
         align-items: center;
         max-width: 65px;
         img.airline-logo {
            $airlineLogoSize: 40px;
            width: $airlineLogoSize;
            height: $airlineLogoSize;
         }
         span.marketing-airline-name {
            font-size: var(--xsmall);
            margin-top: 0.25rem;
            font-weight: 500;
            text-align: center;
            width: 70px;
            word-wrap: normal;
         }
         span.flight-number {
            font-weight: 400;
            font-size: var(--xsmall);
            color: var(--gray-800);
         }
         span.flight-channel {
            color: var(--red-500);
            font-size: var(--xsmall);
            font-weight: 500;
         }
      }

      .flightcard-main-informations {
         display: flex;
         flex-direction: column;
         align-items: center;
         border: 1px solid var(--gray-300);
         border-radius: 1rem;
         padding: 0.35rem 0rem;
         //background-color: var(--gray-50);
         background-color: var(--gray-0);
         min-width: 100px;
         &.opacity {
            opacity: 1;
            cursor: not-allowed;
            display: none;
         }

         div.flightcard-price-wrapper {
            position: relative;
            display: flex;
            flex-direction: column;
            align-items: center;

            .flightcard-discount {
               position: absolute;
               top: -0.5rem;
               font-size: 13px;
               color: var(--gray-500);
               text-decoration: line-through;
               background: var(--gray-50);
               padding: 0 0.5rem;

               border-radius: 0.5rem;
               z-index: 2;
               font-weight: 500;
            }
            .flightcard-basket-price-txt {
               position: absolute;
               top: -1.75rem;
               font-size: 15px;
               color: var(--teal-500);
               font-weight: 500;
               background: var(--gray-50);

               border-radius: 0.5rem;
            }
            .flightcard-price {
               text-align: center;
               font-size: 1.45rem;
               font-weight: 800;
               color: var(--primary);

               padding: 0.125rem 0.35rem;
               position: relative;

               &.basket-price {
                  color: var(--teal-500);
               }
            }
         }
         span.flightcard-price-oneway {
            text-align: center;
            text-decoration: line-through;
            font-size: var(--small);
            font-weight: 600;
            color: var(--primary);
            margin-bottom: 0.25rem;
            display: block;
         }
      }
   }
   .flightcard-footer-wrapper {
      display: flex;
      border-top: 1px solid var(--gray-300);
      background-color: var(--flightcard-footer-wrapper);
      padding: 0.25rem 1rem;
      border-bottom-left-radius: 1rem;
      border-bottom-right-radius: 1rem;
      justify-content: space-between;
      align-items: center;

      .last-seat-attention {
         display: flex;
         color: var(--gray-700);
         font-weight: 500;
         font-size: 0.85rem;
         align-items: center;
         border-radius: 1rem;
         visibility: hidden;

         &.seat-visible {
            color: var(--red-500);
            visibility: visible;
         }

         i {
            margin-right: 0.25rem;
            width: 14px !important;
            height: 14px !important;
            filter: invert(38%) sepia(45%) saturate(3741%) hue-rotate(336deg) brightness(116%) contrast(90%);
         }
      }
      .flightcard-details-toggle {
         display: flex;
         align-items: center;
         i {
            width: 30px !important;
         }
         .toggle-detail-txt {
            margin-left: 0.25rem;
            font-size: var(--small);
            font-weight: 500;
            color: var(--txt-gray);
         }
      }
      span.connections {
         font-size: var(--small);
         font-weight: 500;
      }
      span.operating-airline-name {
         font-size: var(--small);
         font-weight: 500;
         color: var(--gray-700-light);
      }
   }
}
</style>
